export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "talk-JitsiEncryptionWorker.worker.worker.js?v=c072f73c847b88fc108d");
}
